<template>
    <vs-popup :active.sync="isActive" id="recipeReviewer" v-esc="escape">
      <vs-row vs-type="flex" vs-w="12"  class="px-4">
        <vs-row vs-type="flex" vs-w="12">
          <vs-col vs-type="flex" vs-w="4" class="pr-6">
            <img :src="image" alt="img" class="responsive">
          </vs-col>
          <vs-col vs-type="block" vs-w="8">
            <vs-row vs-type="flex" vs-w="12" class="mt-5">
              <span class="w-full bold text-primary text-medium-small2">
                <span>
                  Ürün Açıklaması
                </span>
              </span>
              <span class="weight-500 text-smaller" style="min-height: 10px;">
            
                {{description}}
              </span>
            </vs-row>
          </vs-col>
        </vs-row>
      </vs-row>
    </vs-popup>
  </template>
  <script>
  export default {
    name: "ProductDescription",
    data() {
      return {
        isActive: false,
        name: '',
        description:'',
        image: ''
      }
    },
    methods: {
      escape() {
        if (this.isActive) {
          this.isActive = false
        }
      }
    },
    watch: {
      isActive(val) {
        if (!val) {
          this.$emit("closed")
        }
      }
    }
  }
  </script>
  
  <style>
  #recipeReviewer .vs-popup .vs-popup--header {
    background: unset !important;
    border-radius: 7px 7px 0 0;
  }
  #recipeReviewer .vs-popup {
    width: 800px!important;
    color: #2B2B2B;
  }
  #recipeReviewer .vs-popup--title {
    display: none;
  }
  #recipeReviewer .vs-popup--close {
    position: absolute;
    right: 0;
    top: 0;
  }
  #recipeReviewer .recipeExtraChip {
    background-color: rgba(210, 196, 189, 0.5);
    border-radius: 4px;
    margin-bottom: .5rem;
    padding: 4px 16px!important;
  }
  #recipeReviewer .recipeExtraChip .vs-chip--text {
    margin-left: 0!important;
  }
  </style>
  